export default {
  text: ({ marks, value }, key, h, markRenderer) => {
    if (!marks || !marks.length) return value
    return marks.map((item, i) => {
      if (!markRenderer[item.type]) return value
      return markRenderer[item.type](value, `${key}-${i}`, h)
    })
  },
}
